import { FormItem, Input } from '@vkontakte/vkui';
import React from 'react';
import PropTypes from 'prop-types';
import { prepareNumberValue } from '../../../helpers/helpers';

export const AmountInputComponent = ({error, setError, amount, setAmount, min, max, label, errorTextMin, errorTextMax, placeholder = '0.00'}) => {
  return (<FormItem
    top={label}
    status={error.length > 0 ? 'error' : ''}
    bottom={error}
  >
    <Input
      inputMode="decimal"
      className={'AmountInput'}
      value={amount}
      placeholder={placeholder}
      pattern={'\\d+'}
      onKeyPress={(event) => {
        if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','].includes(event.key)) {
          event.preventDefault();
        }
      }}
      onChange={(event) => {
        if (event.target.value.length < 1) {
          setAmount('');
          return;
        }

        const value = prepareNumberValue(event.target.value.trim());
        if (value.length > 16) {
          return;
        }

        if (value < min) {
          setError(errorTextMin);
        } else if (Number(value) > max) {
          setError(errorTextMax);
          return;
        } else {
          setError('');
        }

        setAmount(value);
      }}
      onBlur={() => {
        const value = Number(prepareNumberValue(amount));
        if (isNaN(value)) {
          setError('');
          setAmount('');
        } else if (value < min) {
          setError(errorTextMin);
          setAmount('');
        } else if (value > max) {
          setError(errorTextMax);
        } else {
          setError('');
          setAmount(value.toFixed(2));
        }
      }}
    />
  </FormItem>);
}

AmountInputComponent.propTypes = {
  error: PropTypes.string.isRequired,
  setError: PropTypes.func.isRequired,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  setAmount: PropTypes.func.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  errorTextMin: PropTypes.string.isRequired,
  errorTextMax: PropTypes.string.isRequired,
};
